import { AuthenticationCtx } from 'components/providers/AuthCtx';
import { Message } from 'data/message';
import { ApiResponse } from 'data/response';
import { post, api } from './api';

const endpoint = "scheduled-appointment";

export const callClient = (authCtx: AuthenticationCtx, number: string): Promise<ApiResponse<Message>> => {
    return post<Message>({
        url: `${api}/${endpoint}/call/${number}`,
        authCtx,
    }).then(res => res);
}
